import get from './get';
import getById from './getById';
import createContract from './createContract';
import updateContract from './updateContract';
import getBookingByPermalik from './getBookingByPermalik';
import sendContract from './sendContract';
import getBookingEvents from './getBookingEvents';
import updateBooking from './updateBooking';
import exportIcs from './exportIcs';
import exportCsvAndXls from './exportCsvAndXls';
import refreshBookings from './refreshBookings';
import assignTeamMemberToBooking from './assignTeamMemberToBooking';
import changeAssignStatus from './changeAssignStatus';
import getBookingsSelectedDay from './getBookingsSelectedDay';
import assignMemberToChecked from './assignMemberToChecked';
import planingGetBookingsSelectedDay from './planingGetBookingsSelectedDay';
import changeEventStatus from './changeEventStatus';
import changeEventStatuses from './changeEventStatuses';
import changePaymentStatus from './changePaymentStatus';
import getBookingsForSorting from './getBookingsForSorting';
import uploadContractSignatureImage from './uploadContractSignatureImage';
import sendContractAuthVerificationCode from './sendContractAuthVerificationCode';
import checkContractAuthVerificationCode from './checkContractAuthVerificationCode';
import validateBookingContractCreate from './validateBookingContractForCreate';
import validateBookingContractUpdate from './validateBookingContractForUpdate';
import resendNotification from './resendNotification';
import downloadContract from './downloadContract';
import getNotAvailableDates from './getNotAvailableDates';
import getNotificationContent from './getNotificationContent';
import updateDetails from './updateDetails';
import checkBookingResource from './checkBookingResource';
import getResources from './getResources';
import createCheckinFormSubmitNotification from './createCheckinFormSubmitNotification';
import checkBookingAvailability from './checkBookingAvailability';
import createBooking from './createBooking';
import retryWebsiteReservationPayment from './retryWebsiteReservationPayment';
import confirmBookingPayment from './confirmBookingPayment';
import reportInvalidCard from './reportInvalidCard';
import cancelReportInvalidCard from './cancelReportInvalidCard';
import regenerateDoorCode from './regenerateDoorCode';
import store from './store';
import getBookingTemplates from './getBookingTemplates';
import updateAirbnbBooking from './updateAirbnbBooking';

export default {
  get,
  getById,
  createContract,
  updateContract,
  getBookingByPermalik,
  sendContract,
  getBookingEvents,
  updateBooking,
  exportIcs,
  exportCsvAndXls,
  refreshBookings,
  assignTeamMemberToBooking,
  changeAssignStatus,
  getBookingsSelectedDay,
  assignMemberToChecked,
  planingGetBookingsSelectedDay,
  changeEventStatus,
  changeEventStatuses,
  changePaymentStatus,
  getBookingsForSorting,
  uploadContractSignatureImage,
  sendContractAuthVerificationCode,
  checkContractAuthVerificationCode,
  validateBookingContractCreate,
  validateBookingContractUpdate,
  resendNotification,
  downloadContract,
  getNotAvailableDates,
  getNotificationContent,
  updateDetails,
  checkBookingResource,
  getResources,
  createCheckinFormSubmitNotification,
  checkBookingAvailability,
  createBooking,
  retryWebsiteReservationPayment,
  confirmBookingPayment,
  reportInvalidCard,
  cancelReportInvalidCard,
  regenerateDoorCode,
  store,
  getBookingTemplates,
  updateAirbnbBooking
};



// WEBPACK FOOTER //
// ./src/app/services/booking/index.js